  export const formatDateTime = (isoString) => {
    if (!isoString) return "-";

    const date = new Date(isoString);

    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZoneName: "short",
    });
  };